export enum FaxRuleTriggerType {
  Sent = "Sent",
  Receive = "Receive",
}
